import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export const showToast = (msg, type = "Success") => {
  toast.dismiss();

  const normalizedType = String(type || "Success").toLowerCase();
  const isSuccess = normalizedType === "success";
  const isWarning = normalizedType === "warning" || normalizedType === "warn";
  const isInfo = normalizedType === "info";

  const toastType = isSuccess
    ? toast.success
    : isWarning
      ? toast.warn
      : isInfo
        ? toast.info
        : toast.error;

  const accentColor = isSuccess
    ? "#00AA44"
    : isWarning
      ? "#F59E0B"
      : isInfo
        ? "#2563EB"
        : "#FF4D4F";

  toastType(
    <div className="flex items-center text-black">
      <span>{msg}</span>
    </div>,
    {
      position: "top-right",
      autoClose: isSuccess ? 2000 : 5000,
      style: {
        backgroundColor: "#fff",
        color: accentColor,
        borderRadius: "8px",
        padding: "12px 20px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        fontSize: "12px",
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
        border: `1px solid ${accentColor}`,
      },
    }
  );
};
